import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Button, Card, Row, Col, Modal, ListGroup, Table } from 'react-bootstrap';
import discountlogo from './../../assets/discountlogo.png';
import styles from './sellerdiscountblock1.module.css';
import SellerDiscountBlock2 from '../SellerDiscountBlock2';
import ImageWithFallback from '../ImageWithFallback';
import { getDiscountsList } from '../../apis/discount';
import { useCookies } from 'react-cookie';
import { DataGrid } from '@mui/x-data-grid/DataGrid';
import { useTranslation } from 'react-i18next';
import { toast, Bounce } from 'react-toastify';


function SellerDiscountBlock1() {
  const [showModal, setShowModal] = useState(false);
  const [showBlock2, setShowBlock2] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });

  const { t } = useTranslation();
  const [cookie, setCookie] = useCookies(["access_token", "user_info"]);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleSelectDiscountType = (type) => {
    if (type === 'Giảm giá theo sản phẩm') {
      setShowBlock2(true);
    }
    setShowModal(false);
  };

  const handleBackToBlock1 = () => {
    setShowBlock2(false);
  };

  useEffect(() => {
    handlePaginationChange(paginationModel);
  }, [])

  if (showBlock2) {
    return <SellerDiscountBlock2 onBack={handleBackToBlock1} />;
  }

  const columns = [
    { field: "id", headerName: "ID", width: 300 },
    {
      field: "title",
      headerName: t("discount_title"),
      width: 200
    },
    {
      field: "discountCode",
      headerName: t("discount_code"),
      width: 200
    },
    { field: "discountMethod", headerName: t("discount_method"), width: 200 },
    { field: "discountValue", headerName: t("discount_value"), width: 150 },
    { field: "limitPerCustomer", headerName: t("limit_per_customer"), width: 100 },
    { field: "maxTotalRedemptions", headerName: t("max_redemp"), width: 150 },
    { field: "minimumPurchaseAmount", headerName: t("min_purchase_amount"), width: 250 },
    { field: "minimumPurchaseQuantity", headerName: t("min_purchase_quantity"), width: 250 },
    {
      field: "combinableDiscounts", headerName: t("combine_discounts"), width: 300, renderCell: (params) => (
        <div style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
          {params.value.join(", ")}
        </div>
      ),
    },
    {
      field: "specificCustomerSegments", headerName: t("specific_customers"), width: 250, renderCell: (params) => (
        <div style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
          {params.value.join(", ")}
        </div>
      ),
    },
    {
      field: "specificProducts",
      headerName: t("specific_products"),
      width: 200,
      renderCell: (params) => (
        <div style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
          {params.value.join(", ")}
        </div>
      ),
    },
    {
      field: "totalUse",
      headerName: t("totalUse"),
      type: "number",
      width: 150,
    },
    {
      field: "status",
      headerName: t("status"),
      width: 100,
    },
    {
      field: "noMinimumRequirement",
      headerName: t("no_min_require"),
      width: 200,
    },
    { field: "startDate", headerName: t("start_date"), width: 180 },
    {
      field: "startTime",
      headerName: t("start_time"),
      type: "string",
      width: 150,
    },
    {
      field: "endDate",
      headerName: t("end_date"),
      type: "string",
      width: 130,
    },
    {
      field: "endTime",
      headerName: t("end_time"),
      type: "string",
      width: 130,
    },
  ];

  const handlePaginationChange = async (newPaginationModel) => {
    setPaginationModel(newPaginationModel);

    toast.promise(new Promise(async (resolve, reject) => {
      getDiscountsList(cookie["user_info"].sellerId, newPaginationModel.perPage ? newPaginationModel.perPage : 25, newPaginationModel.page ? newPaginationModel.page : 0, cookie["access_token"]).then(result => {
        if (result.status === 200) {
          resolve(result)
          setDiscounts(result.data.data)
        }
        else reject(result)
      })
    }), {
      pending: {
        render() {
          return t("loading");
        },
        position: "top-center",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      },
      success: {
        render({ result }) {
          return t("loaded");
        },
      },
      error: {
        render({ result }) {
          return `${t("error_occurred")}: ${result.response?.result?.message || result.message}`;
        },
      },
    },
    )
  };

  return (
    <Container className={`${styles.block} my-4`}>
      {discounts.length !== 0
        ?
        <Card className={`mb-3 ${styles.card}`}>
          <div className="d-flex justify-content-between align-items-center p-3">
            <h2>Giảm giá</h2>
            <div>
              
              <Button variant="outline-secondary" className="me-2">Xuất</Button>
              <Button variant="warning" onClick={handleShow}>Tạo chương trình</Button>
            </div>
          </div>
          <Card.Body>
            <div className="d-flex mb-3">
              <Button variant="light" className="me-2">Tất cả</Button>
              <Button variant="light" className="me-2">Đang hoạt động</Button>
              <Button variant="light" className="me-2">Đã lên lịch</Button>
              <Button variant="light" className="me-2">Đã hết hạn</Button>
              <Button variant="light">+</Button>
            </div>
            <DataGrid
              sx={{ ".MuiDataGrid-cell": { overflowY: "auto" } }}
              disableRowSelectionOnClick
              disableColumnResize
              rowHeight={150}
              rows={discounts}
              columns={columns}
              paginationMode="server"
              pagination
              rowCount={100}
              initialState={{
                pagination: {
                  paginationModel: paginationModel,
                },
              }}
              pageSizeOptions={[5, 10]}
              onPaginationModelChange={handlePaginationChange}
            />
            <div className="text-center mt-3">
              <a>Tìm hiểu thêm về <a href="#" className="text-decoration-none text-primary">Chương trình giảm giá</a></a>
            </div>
          </Card.Body>
          <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Chọn kiểu giảm giá</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ListGroup variant="flush">
                <ListGroup.Item onClick={() => handleSelectDiscountType('Giảm giá theo sản phẩm')}>
                  <div className="d-flex justify-content-between">
                    <span>Số lượng sản phẩm</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Giảm giá theo sản phẩm</small>
                </ListGroup.Item>
                <ListGroup.Item onClick={() => handleSelectDiscountType('Giảm giá theo tổng số tiền đặt hàng')}>
                  <div className="d-flex justify-content-between">
                    <span>Số lượng đơn đặt hàng</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Giảm giá theo tổng số tiền đặt hàng</small>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex justify-content-between">
                    <span>Mua X tặng Y</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Tặng thêm sản phẩm</small>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex justify-content-between">
                    <span>Giảm phí vận chuyển</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Giảm phí vận chuyển</small>
                </ListGroup.Item>
              </ListGroup>
            </Modal.Body>
          </Modal>
        </Card>
        :
        <>
          <Row className="justify-content-center">
            <Col xs={12} md={8}>
              <Card className={`${styles.box} text-center p-4`}>
                <Card.Body>
                  <ImageWithFallback loading="lazy" src={discountlogo} alt="Discount Logo" style={{ width: '90px', height: '90px' }} />
                  <Card.Title className="mt-3">Quản lý chương trình giảm giá, khuyến mãi</Card.Title>
                  <Card.Text>
                    Tạo mã giảm giá và các khuyến mãi tự động để áp dụng vào mục mua hàng.
                  </Card.Text>
                  <Button variant="warning" onClick={handleShow}>Tạo chương trình</Button>
                  <Row>
                    <a>Tìm hiểu thêm về <a href="#" className="text-decoration-none text-primary">Chương trình giảm giá</a></a>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Chọn kiểu giảm giá</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ListGroup variant="flush">
                <ListGroup.Item onClick={() => handleSelectDiscountType('Giảm giá theo sản phẩm')}>
                  <div className="d-flex justify-content-between">
                    <span>Số lượng sản phẩm</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Giảm giá theo sản phẩm</small>
                </ListGroup.Item>
                <ListGroup.Item onClick={() => handleSelectDiscountType('Giảm giá theo tổng số tiền đặt hàng')}>
                  <div className="d-flex justify-content-between">
                    <span>Số lượng đơn đặt hàng</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Giảm giá theo tổng số tiền đặt hàng</small>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex justify-content-between">
                    <span>Mua X tặng Y</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Tặng thêm sản phẩm</small>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex justify-content-between">
                    <span>Giảm phí vận chuyển</span>
                    <span>&gt;</span>
                  </div>
                  <small className="text-muted">Giảm phí vận chuyển</small>
                </ListGroup.Item>
              </ListGroup>
            </Modal.Body>
          </Modal>
        </>
      }
    </Container>
  );
}

export default SellerDiscountBlock1;
